"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import "../../app/globals.css";
import { Navigation } from "swiper/modules";

import "swiper/css/pagination";
import { getStrapiMedia } from "@/utils/api-helpers";

export default function ReelsSlider({ slides }: { slides?: any }) {
    const [isMounted, setIsMonted] = useState(false);

    useEffect(() => {
        setIsMonted(true);
    }, []);

    function handleSlideChange(swiper: any) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide.querySelector("video");

        const allVideos = document.querySelectorAll(".swiper-slide video");
        allVideos.forEach((video: any) => {
            if (video !== activeVideo) {
                video.pause();
            }
        });

        if (activeVideo) {
            activeVideo.play();
        }
    }

    return (
        <>
            {isMounted && (
                <Swiper
                    slidesPerView={1.4}
                    spaceBetween={40}
                    loop={true}
                    centeredSlides={true}
                    navigation={true}
                    modules={[Navigation]}
                    allowTouchMove={true}
                    onSlideChange={(swiper) => handleSlideChange(swiper)}
                    breakpoints={{
                        565: {
                            slidesPerView: 2,
                            spaceBetween: 40,
                        },
                        768: {
                            slidesPerView: 2.8,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 4.2,
                            spaceBetween: 40,
                        },
                    }}
                    className="reelsSlider w-full !overflow-visible"
                >
                    {slides.map((video: any, index: number) => {
                        return (
                            <SwiperSlide
                                key={`video-` + index}
                                className="aspect-[9/16] rounded-3xl overflow-hidden p-3 border-[1px] border-white !bg-[#ffffff3b]"
                            >
                                <video
                                    src={getStrapiMedia(video.video.url)}
                                    muted
                                    playsInline
                                    loop
                                    className="w-full h-full object-cover rounded-2xl"
                                ></video>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </>
    );
}
